import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import store from "../store/store";
import { logoutUser } from "../actions/userActions";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const Utils = (function () {
  const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

  const getToken = function () {
    const encryptedData = Cookies.get("uuid");
    if (!encryptedData) return false;
    const encryptionKey = ENCRYPTION_KEY;
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, encryptionKey);
      const token = bytes.toString(CryptoJS.enc.Utf8);
      if (!token) {
        return false;
      }
      return token;
    } catch (error) {
      return false;
    }
  };
  const setLoggedInUser = function (userObj) {
    return new Promise((resolve, rej) => {
      try {
        const user = JSON.stringify(userObj);
        const userDetails = CryptoJS.AES.encrypt(
          user,
          ENCRYPTION_KEY
        ).toString();
        Cookies.set("ud", userDetails, {
          secure: true,
          sameSite: "Lax",
          expires: 7,
        });
        resolve();
      } catch (error) {
        console.error("Error setting user data:", error);
        return false;
      }
    });
  };
  const getLoggedInUser = function () {
    const encryptedData = Cookies.get("ud");
    const encryptionKey = ENCRYPTION_KEY;
    if (!encryptedData) {
      return null; // No user data found in cookies
    }
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, encryptionKey);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptedData) {
        throw new Error("Decryption failed. The key might be incorrect.");
      }

      const userObj = JSON.parse(decryptedData);
      return userObj;
    } catch (error) {
      console.error("Error retrieving user data:", error.message);
      return null;
    }
  };

  return {
    getToken,
    setLoggedInUser,
    getLoggedInUser,
    getUserAvatar: function (userName) {
      if (!userName) return "";
      return userName
        .trim()
        .split(" ")
        .splice(0, 2)
        .reduce((image, name) => {
          return image + name[0];
        }, "");
    },
    getUserFirstName: function (name) {
      if (!name) return "There";
      const names = name.split(" ");
      return names[0];
    },
    getRandomColor: function () {
      const colors = [
        "bg-red-500",
        "bg-blue-500",
        "bg-green-500",
        "bg-yellow-500",
        "bg-purple-500",
        "bg-pink-500",
        "bg-indigo-500",
        "bg-gray-500",
        "bg-red-700",
        "bg-blue-700",
        "bg-green-700",
        "bg-yellow-700",
        "bg-purple-700",
        "bg-pink-700",
        "bg-indigo-700",
      ];
      const randomIndex = Math.floor(Math.random() * colors.length);
      return colors[randomIndex];
    },
    getRandomBgColor: function () {
      const tailwindColors = [
        "bg-red-500",
        "bg-blue-500",
        "bg-green-500",
        "bg-yellow-500",
        "bg-purple-500",
        "bg-pink-500",
        "bg-indigo-500",
        "bg-gray-500",
        "bg-red-700",
        "bg-blue-700",
        "bg-green-700",
        "bg-yellow-700",
        "bg-purple-700",
        "bg-pink-700",
        "bg-indigo-700",
        "bg-red-200",
        "bg-green-200",
        "bg-blue-200",
        "bg-yellow-200",
        "bg-pink-200",
        "bg-purple-200",
        "bg-indigo-200",
        "bg-teal-200",
        "bg-orange-200",
        "bg-gray-200",
        "bg-red-200",
        "bg-green-200",
        "bg-blue-200",
        "bg-yellow-200",
        "bg-pink-200",
        "bg-purple-200",
        "bg-indigo-200",
        "bg-teal-200",
        "bg-orange-200",
        "bg-gray-200",
        "bg-red-200",
        "bg-red-200",
        "bg-pink-200",
        "bg-pink-200",
        "bg-purple-200",
        "bg-purple-200",
        "bg-indigo-200",
        "bg-indigo-200",
        "bg-blue-200",
        "bg-blue-200",
        "bg-cyan-200",
        "bg-cyan-200",
        "bg-teal-200",
        "bg-teal-200",
        "bg-green-200",
        "bg-green-200",
        "bg-lime-200",
        "bg-lime-200",
        "bg-yellow-200",
        "bg-yellow-200",
        "bg-amber-200",
        "bg-amber-200",
        "bg-orange-200",
        "bg-orange-200",
        "bg-rose-200",
        "bg-rose-200",
        "bg-emerald-200",
        "bg-emerald-200",
        "bg-gray-200",
        "bg-gray-200",
        "bg-slate-200",
        "bg-slate-200",
        "bg-zinc-200",
        "bg-zinc-200",
        "bg-neutral-200",
        "bg-neutral-200",
        "bg-stone-200",
        "bg-stone-200",
      ];
      const randomIndex = Math.floor(Math.random() * tailwindColors.length);
      return tailwindColors[randomIndex];
    },
    setToken: function (token) {
      return new Promise((resolve) => {
        const encryptedData = CryptoJS.AES.encrypt(
          token,
          ENCRYPTION_KEY
        ).toString(); // Converting encrypted data to a Base64 string

        Cookies.set("uuid", encryptedData, {
          secure: true,
          sameSite: "Lax",
          expires: 7,
        });
        resolve(); // Resolve after setting the token
      });
    },
    getUserRole: function () {
      const user = Utils.getLoggedInUser();
      if (!user) return null;
      if (user.role) return user.role;
      return null;
    },
    get UserRole() {
      return this.getUserRole();
    },
    logOut: function () {
      Cookies.remove("uuid");
      Cookies.remove("ud");
      store.dispatch(logoutUser());
    },
    getIndianTimeFromJSON: function (lecturetime) {
      if (!lecturetime) return;
      let [date, empty, time, am_pm] = new Date(lecturetime)
        .toLocaleString()
        .split(/[", ]/);

      const [month, day, year] = date.split("/");
      const [hour, minute, sec] = time.split(":");
      return `${day} ${months[month - 1]}, ${year}, ${hour}:${minute} ${am_pm}`;
    },
    getCurrentTime: function () {
      return new Date().getTime();
    },
    getDate: function (updatedAt) {
      let [month, day, year] = new Date(updatedAt)
        .toLocaleDateString()
        .split("/");
      day = day.padStart(2, 0);
      const currentDate = `${day}-${months[month - 1]}-${year}`;
      return currentDate;
    },
    validateName: function (name) {
      const pattern = /^[A-Z][a-z]*([ ][A-Z][a-z]*)*$/;
      return pattern.test(name);
    },
    validateEmail: function (email) {
      const pattern = /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|}~]+@gmail\.com$/;
      return pattern.test(email);
    },
    validateMobileNumber: function (mobileNumber) {
      const pattern = /^\d{10}$/;
      return pattern.test(mobileNumber);
    },
    getFullCourseName: function (name) {
      switch (name) {
        case "PGP":
          return "Data Science PG Program";
        case "AI":
          return "Artificial Intelligence";
        case "WEB":
          return "Full Stack Web Development";
        default:
          return name;
      }
    },
    getCurrentDateTimeIndianTimeZone: function () {
      const date = new Date().getDate().toString().padStart(2, 0);
      const month = (1 + new Date().getMonth()).toString().padStart(2, 0);
      const year = new Date().getFullYear();
      const hours = new Date().getHours();
      const minute = new Date().getMinutes();
      const seconds = new Date().getSeconds();

      return {
        date: `${year}-${month}-${date}`,
        time: String(new Date()).slice(16, 21),
      };
    },
    getDateTimeUTCToLocal: function (utcString) {
      // const localDate = new Date(utcString);
      // const date = localDate.toISOString().slice(0, 10);
      // const time = localDate.toTimeString().slice(0, 5);
      // return { date, time };

      const dt = new Date(utcString);
      // Format date as YYYY-MM-DD
      const date = dt.toLocaleDateString("en-CA"); // en-CA gives YYYY-MM-DD format
      // Format time as HH:mm
      const time = dt.toLocaleTimeString("en-GB", {
        // en-GB gives 24-hour format
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return { date, time };
    },
    getLectureDuration: function (startUTC, endUTC) {
      if (!startUTC || !endUTC) return { hours: 0, minutes: 0 };
      const start = new Date(startUTC);
      const end = new Date(endUTC);
      const differenceMs = end - start;

      const totalMinutes = Math.floor(differenceMs / (1000 * 60));
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return { hours, minutes };
    },
    getCreationTime: function (date, time) {
      const localDateTime = `${date}T${time}`;

      // Create date object in local timezone
      const dt = new Date(localDateTime);

      // Convert to UTC ISO string while preserving the local time
      return dt.toISOString();
      // Ensure we create the date properly by combining date and time
      // const [year, month, day] = date
      //   .split("-")
      //   .map((num) => parseInt(num, 10));
      // const [hours, minutes] = time.split(":").map((num) => parseInt(num, 10));
      // return new Date(year, month - 1, day, hours, minutes).toISOString();
    },
    formatDateTime: function (dateString, dateOrTime, numeric) {
      if (!dateString) return "-";
      const match =
        !Number(dateString) && dateString.match(/^(\d{4})-(\d{2})$/);
      if (match) {
        const [_, year, month] = match;
        const date = new Date(`${year}-${month}-01`);
        return date.toLocaleString("en-US", {
          month: "short",
          year: "numeric",
        });
      }
      if (dateString && !isNaN(Number(dateString))) {
        const date = new Date(Number(dateString));
        const options = {
          year: "numeric",
          month: numeric ? "numeric" : "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        };

        if (dateOrTime === "date") {
          delete options["hour"];
          delete options["minute"];
          delete options["hour12"];
        }

        if (dateOrTime === "time") {
          delete options["year"];
          delete options["month"];
          delete options["day"];
        }
        return date.toLocaleString(undefined, options);
      }

      let date;

      try {
        // First try parsing as is
        date = new Date(dateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
          // If the date is invalid, try parsing UTC string
          date = new Date(new Date(dateString).toUTCString());
        }

        // If still invalid, throw error
        if (isNaN(date.getTime())) {
          throw new Error("Invalid date");
        }
      } catch (error) {
        console.error("Error parsing date:", dateString);
        return "-";
      }

      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      // Convert to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12;

      return `${day} ${month}, ${year}, ${hours}:${minutes} ${ampm}`;
    },
    getDuration: function (date) {
      if (typeof date === "string") {
        date = new Date(date).getTime();
      }
      const givenDate = new Date(date);
      const today = new Date();
      const diffInMillis = today - givenDate;
      const totalDays = Math.floor(diffInMillis / (1000 * 60 * 60 * 24));
      return totalDays;
    },
    getAssessmentMonths(time) {
      let regDate;
      if (typeof time === "string") {
        regDate = new Date(time).getTime();
      } else {
        regDate = new Date(time);
      }
      const thresholdDay = 10;
      let startMonthDate;
      if (regDate.getDate() > thresholdDay) {
        startMonthDate = new Date(
          regDate.getFullYear(),
          regDate.getMonth() + 1,
          1
        );
      } else {
        startMonthDate = new Date(regDate.getFullYear(), regDate.getMonth(), 1);
      }
      const assessmentMonths = [];
      for (let i = 0; i < 8; i++) {
        const currentMonthDate = new Date(
          startMonthDate.getFullYear(),
          startMonthDate.getMonth() + i,
          1
        );
        // Format the month as YYYY-MM
        const year = currentMonthDate.getFullYear();
        const month = (currentMonthDate.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        assessmentMonths.push(`${year}-${month}`);
      }
      return assessmentMonths;
    },
  };
})();

export default Utils;
